import { AbstractControl } from '@angular/forms';
import { InputValidationErrors } from '@libs/form/models';

export class PostalCodeValidator {
  private static readonly postalCodeRegexp: RegExp = /^\d{5}$/;

  public static validate(control: AbstractControl): InputValidationErrors | null {
    const value: unknown = control.value;

    if (
      !(typeof value === 'string') ||
      control.value === '' ||
      PostalCodeValidator.postalCodeRegexp.test(value)
    ) {
      return null;
    }

    return {
      postalCode: true,
    };
  }
}
